import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, typography }) =>
  createStyles({
    container: {
      padding: '1rem 1rem 0.8rem',
    },
    card: {
      backgroundColor: '#F0F1EB',
      padding: '1.6rem',
      borderRadius: 4,

      '& h3': {
        fontSize: '2.4rem',
      },

      '& button': {},
    },
    inputsContainer: {
      marginTop: '1.6rem',
      display: 'flex',
      gap: '1.6rem',
      flexDirection: 'column',

      '& .MuiTextField-root': {
        width: '100%',
        margin: 0,

        '& .MuiInputBase-root': {
          backgroundColor: palette.background.paper,
        },
      },

      '& .MuiAutocomplete-root': {
        width: '100%',
      },
    },
    iconButton: {
      height: 'fit-content',
      marginTop: '1rem',
    },
    treatmentCost: {
      '& label': {
        display: 'flex',
        gap: '1rem',

        '& > div': {
          width: '13rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          paddingInline: '0.8rem',
          borderRadius: 4,
          outline: `1px solid ${palette.secondary.light}`,

          color: '#727970',
          fontFamily: typography.body1.fontFamily,
          fontWeight: 600,
          backgroundColor: palette.background.paper,
          fontSize: '1.4rem',
          boxSizing: 'border-box',

          '& input': {
            border: 'none',
            outline: 'none',
            color: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            fontSize: 'inherit',
            textAlign: 'right',
            width: '100%',
          },

          '&:focus-within': {
            outlineWidth: 2,
          },
        },
      },

      '& > p': {
        marginLeft: '1.6rem',
      },
    },

    button: {
      width: '18rem',
      minWidth: 'fit-content',
      height: '3.2rem',
      margin: 0,

      fontSize: '1.2rem',
      fontWeight: 600,
      letterSpacing: '0.1rem',
    },
  }),
)
